module.exports = __webpack_public_path__ + "img/pageLogo.5f1bb17e.png";